module.exports = __webpack_public_path__ + "static/media/img70.3ae37fb6.png";